"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGoogleCloudSearch = void 0;
var react_1 = __importStar(require("react"));
var uuid_1 = require("uuid");
var config_1 = require("./config");
var utils_1 = require("./utils");
function useGoogleCloudSearch(_a) {
    var clientId = _a.clientId, googleSearchApplicationId = _a.googleSearchApplicationId, interceptSearchRequest = _a.interceptSearchRequest, interceptSearchResponse = _a.interceptSearchResponse, isGapiLoaded = _a.isGapiLoaded, searchInputId = _a.searchInputId;
    var searchApplicationName = "searchapplications/".concat(googleSearchApplicationId);
    var _b = (0, react_1.useState)(), resultsContainerResult = _b[0], setResultsContainer = _b[1];
    var _c = (0, react_1.useState)(), searchBoxResult = _c[0], setSearchBox = _c[1];
    var hiddenSearchResultsId = (0, react_1.useMemo)(function () {
        return (0, uuid_1.v4)();
    }, []);
    var hiddenSuggestionsAnchorId = (0, react_1.useMemo)(function () {
        return (0, uuid_1.v4)();
    }, []);
    var hiddenAnchors = (0, react_1.useMemo)(function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { id: hiddenSearchResultsId, style: { display: 'none' } }),
            react_1.default.createElement("div", { id: hiddenSuggestionsAnchorId, style: { display: 'none' } })));
    }, [hiddenSearchResultsId, hiddenSuggestionsAnchorId]);
    var resultsContainerAdapter = (0, react_1.useMemo)(function () {
        return {
            interceptSearchRequest: interceptSearchRequest,
            interceptSearchResponse: interceptSearchResponse,
        };
    }, [interceptSearchRequest, interceptSearchResponse]);
    // Load cloud search widget and bind to html elements.
    (0, react_1.useEffect)(function () {
        if (!isGapiLoaded)
            return;
        var gapi = (0, utils_1.getGapi)();
        gapi.auth2
            .init({
            client_id: clientId,
            hosted_domain: config_1.googleSearchConfig.hostedDomain,
            scope: config_1.googleSearchConfig.queryScope,
        })
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then(function (auth) {
            var currentUser = auth.currentUser.get();
            var grantedScopes = currentUser === null || currentUser === void 0 ? void 0 : currentUser.getGrantedScopes();
            if (!grantedScopes || !grantedScopes.includes(config_1.googleSearchConfig.queryScope)) {
                gapi.auth2.getAuthInstance().signIn();
            }
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var resultsContainer = new gapi.cloudsearch.widget.resultscontainer.Builder()
            .setAdapter(resultsContainerAdapter)
            .setSearchApplicationId(searchApplicationName)
            .setSearchResultsContainerElement(document.getElementById(hiddenSearchResultsId))
            .setIncludePagination(false)
            .build();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var searchBox = new gapi.cloudsearch.widget.searchbox.Builder()
            .setSearchApplicationId(searchApplicationName)
            .setInput(document.getElementById(searchInputId))
            .setAnchor(document.getElementById(hiddenSuggestionsAnchorId))
            .setResultsContainer(resultsContainer)
            .build();
        setResultsContainer(resultsContainer);
        setSearchBox(searchBox);
        return function () {
            resultsContainer.dispose();
            searchBox.dispose();
        };
    }, [
        searchApplicationName,
        isGapiLoaded,
        resultsContainerAdapter,
        hiddenSearchResultsId,
        hiddenSuggestionsAnchorId,
        searchInputId,
    ]);
    return [hiddenAnchors, resultsContainerResult, searchBoxResult];
}
exports.useGoogleCloudSearch = useGoogleCloudSearch;
